import { ActListVM } from 'civil-status/view-models/research-category-form';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCellsAct: HeadCell<ActListVM, keyof ActListVM>[] = [
  {
    id: 'holders',
    label: 'Intestatari',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'typeContent',
    label: 'Tipo contenuto',
  },
  {
    id: 'typology',
    label: 'Tipologia atto',
  },
  {
    id: 'dateFormation',
    label: 'Data formazione',
  },
  // {
  //   id: 'idSubject',
  //   label: 'ID Ansc Soggetto',
  // },
  {
    id: 'idAnsc',
    label: 'ID Ansc',
  },
  {
    id: 'municipality',
    label: 'Comune',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const headCellsPerson: HeadCell<ActListVM, keyof ActListVM>[] = [
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'idAnsc',
    label: 'ID Ansc Soggetto',
  },
  {
    id: 'fiscalCode',
    label: 'Codice fiscale',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'municipality',
    label: 'Comune',
  },
  {
    id: 'dateBorn',
    label: 'Data di nascita',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
